/**
 * 수출입 — /imports (2026-07-19 메뉴 재구성으로 매입관리 탭에서 독립 승격, 관리 그룹).
 *
 * 내용은 기존 ImportExportTab 그대로 (인포트렌드 수입 오더 · RMA 왕복 · 부대비용 배분 · 실제 원가).
 * 권한: 경영+(mgmt·admin) 전용 — 단가/할인율 민감 정보 (기존 탭 노출 조건·백엔드 제한과 동일).
 *
 * v2.244.0 — 탭 두 개였다: [🚢 수출입] · [📮 개발요청](사용자 결정 10-13 「수출입 화면 안의 탭」).
 * v2.274.0 (2026-10-18 사용자 「수출입에 있는 개발요청 메뉴 위치와 범위를 확대」) — 개발요청은 **전 메뉴**로 넓혀
 *   「📮 개발요청」 메뉴(/dev-plan) 게시판으로 옮겼다(요청은 어느 화면에서든 오른쪽 위 단추). 탭은 없앴고,
 *   옛 주소 `?tab=requests` 는 게시판의 수출입 요청으로 넘긴다(즐겨찾기·옛 링크가 깨지지 않게).
 */

import { lazy, Suspense } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { ImportPartnerSection } from '../components/ImportPartnerSection';
import { LoadingLines } from '../components/ui/Skeleton';

const ImportExportTab = lazy(() =>
  import('../components/ImportExportTab').then((m) => ({ default: m.ImportExportTab })),
);

export function ImportExportPage() {
  const { user } = useAuth();
  const allowed = user?.role === 'mgmt' || user?.role === 'admin';
  const [params] = useSearchParams();

  if (params.get('tab') === 'requests') {
    return <Navigate to={`/dev-plan?menu=${encodeURIComponent('/imports')}`} replace />;
  }
  if (!allowed) {
    return (
      <div className="p-8">
        <div className="bg-white rounded border border-slate-200 p-12 text-center">
          <div className="text-5xl mb-3">🔒</div>
          <div className="text-lg font-bold text-slate-700">경영(mgmt) 이상 전용 메뉴입니다</div>
          <p className="text-sm text-slate-500 mt-2">수출입 원가·할인율 정보는 경영진만 열람할 수 있습니다.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="p-8">
      <h1 className="ui-page-title">수출입</h1>
      <p className="ui-page-sub mb-3">
        인포트렌드 수입 오더 · RMA 왕복 · 부대비용 배분 · 실제 원가
      </p>
      <Suspense fallback={<div className="py-16 text-center text-slate-400"><LoadingLines /></div>}>
        <ImportExportTab />
      </Suspense>
      {/* 🏷 국세청 자동분류 거래처 명단 (v2.131.0) — 접힌 절. 오더·비용 표 아래. */}
      <ImportPartnerSection />
    </div>
  );
}
